export const SET_CURRENT_INVOICE_CODE_FOR_TRANSACTION = 'SET_CURRENT_INVOICE_CODE_FOR_TRANSACTION';
export const CLEAR_CURRENT_INVOICE_CODE_FOR_TRANSACTION = 'CLEAR_CURRENT_INVOICE_CODE_FOR_TRANSACTION';
